import React, { useEffect, useState } from 'react';
import style from './content-preview.module.scss';
import FlowIcon from '../../../../../../../assets/svg/solo-chat/flow.svg';
import MessageIcon from '../../../../../../../assets/svg/solo-chat/chat.svg';
import ShuffleIcon from '../../../../../../../assets/svg/solo-chat/shuffle.svg';
import ImageIcon from '../../../../../../../assets/svg/solo-chat/image.svg';
import ExpandIcon from '../../../../../../../assets/svg/solo-chat/expand-2.svg';
import {  Content as TContent } from '../types';
import { Content } from '../../content/types';
import { useQuery, useAppAndBranchId } from '../../../hooks';
import { api } from '../../content/api';
import { PreviewContent } from '../createDialog/components/PreviewContent';
import { labelMap } from '../../../../soloJourney/properties/message/components';
import { Icon, Spin } from 'antd'

type Props = {
	name: string;
	hasImage: boolean;
	messageCount: number;
	isRandom: boolean;
	isFlow: boolean;
	data: TContent;
	openContent: (data: TContent) => void;
	isService?: boolean
};

export function ContentPreview(props: Props) {
	const { data, openContent } = props;
	const flowName = data.type === 'flow' ? data.flowName : undefined
	const contentId = data.type === 'message' ? data.messages[0] : ''
	const [appId, branchId] = useAppAndBranchId()
    const [contents,setContents]=useState<Content[]>([])
	const [loading,setLoading]=useState(false)

	useEffect(() => {
		if (contentId && !props.isService && appId && branchId) {
			getChatContents()
		} else {
			setContents([])
		}
	}, [contentId,appId,branchId])

	const getChatContents = async () => {
		try {
			setLoading(true)
			const resp: Content[] = await api.getChatContentsByIds(appId, branchId, [contentId])
			setContents(resp)
		} catch (e) {
			console.error(e)
		} finally {
			setLoading(false)
		}
	}
	return (
		<div className={style.contentPreview}>
			{!props.isService && flowName && <p className="text-ellipsis">{flowName}</p>}
			{loading && (
				<Spin indicator={<Icon type="loading" style={{ fontSize: 16, color: '#15808C' }} spin />} />
			)}
			{Array.isArray(contents) && contents.length ? (
				<PreviewContent
					headless
					contentId={contents[0].contentId}
					contentType={contents[0].contentType}
					key={contents[0].id}
					contentValue={{...contents[0].contentValue, id: contents[0].id}}
					remove={() => {}}
					title={
						(contents[0].contentValue as any)[labelMap[contents[0].contentType]]
					}
				/>
			) : <p style={{ flex: 1 }}>{props.isService ? props.name : ''}</p>}
			<div className={style.info}>
				<div>
					{props.isRandom && <img title="Random Messages" src={ShuffleIcon} alt="random" />}
					{props.hasImage && <img title="Has Image" src={ImageIcon} alt="image" />}
					{props.isFlow && <img title="Flow" src={FlowIcon} alt="flow" />}
					{Boolean(props.messageCount) && (
						<div title="Message Count">
							<img src={MessageIcon} alt="message" />
							<span>{props.messageCount}</span>
						</div>
					)}
				</div>
				<button title="View Messages" onClick={() => openContent(data)}>
					<img src={ExpandIcon} alt="expanad" />
				</button>
			</div>
		</div>
	);
}
